<template>
  <div>
    <div class="swiper-container-buy-person" v-if="buyperson.length > 0">
	  <swiper :options="swiperOptionBuy" v-if='showBuyperson'>
		<swiper-slide v-for="(item,key) in buyperson" :key="key">
			<img class="swiper-img-buy" :src="item.avatar" alt=""><span class="swiper-buy-person-name">{{item.nickname}}</span><span>购买了该商品</span>
		</swiper-slide>
	  </swiper>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
export default {
  name: "BuyPerson",
  props: {
    buyperson: Array,
    showBuyperson: Boolean
  },
  components:{
	swiper,
	swiperSlide
  },
  data: function() {
    return {
      swiperOptionBuy: {
		direction: 'vertical',
		autoplay: {
		  disableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止
		  delay: 500
		},
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {},
  methods: {
    
  }
};
</script>
<style scoped>
.swiper-container-buy-person{
	width: auto;
	height: 0.8rem;
	overflow: hidden;
	position: fixed;
	top: 1rem;
	left: 0.3rem;
	z-index: 999;
}
.swiper-container-buy-person .swiper-container{
	height: 0.8rem;
	pointer-events: none;
}
.swiper-container-buy-person .swiper-slide{
	width: auto;
	height: 0.6rem!important;
	overflow: hidden;
	/* line-height: 0.45rem; */
	padding: 0 0.3rem;
	background: rgba(0,0,0,0.6);
	color: #fff;
	border-radius: 17px;
	margin-bottom: 1rem;
	display: flex;
	align-items: center;
}
.swiper-img-buy{
	width: 0.4rem;
	height: 0.4rem;
	display: inline-block;
	border-radius: 50%;
	margin-right: 0.2rem;
}
.swiper-container-buy-person span{
	font-size: 0.24rem;
	display: inline-block;
	width: 1.6rem;
	height: 0.35rem;
	overflow: hidden;
}
.swiper-container-buy-person .swiper-buy-person-name{
	width: 0.6rem;
}
@media screen and (min-width:960px){
	.swiper-container-buy-person{
		height: 0.4rem;
		top: 0.5rem;
		left: 0.15rem;
	}
	.swiper-container-buy-person .swiper-container{
		height: 0.4rem;
	}
	.swiper-container-buy-person .swiper-slide{
		height: 0.3rem!important;
		padding: 0 0.15rem;
		margin-bottom: 0.5rem;
	}
	.swiper-img-buy{
		width: 0.2rem;
		height: 0.2rem;
		margin-right: 0.1rem;
	}
	.swiper-container-buy-person span{
		font-size: 0.12rem;
		width: 0.8rem;
		height: 0.175rem;
	}
	.swiper-container-buy-person .swiper-buy-person-name{
		width: 0.3rem;
	}
}
</style>
